import { EyeIcon } from "@heroicons/react/24/outline";

export default function FamilleCard({ family, onClick }) {
  return (
    <div
      onClick={onClick}
      className="relative bg-white shadow rounded-xl border border-gray-200 p-4 flex flex-col items-center text-center hover:shadow-md transition group cursor-pointer"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
    >
      {/* Logo ou initiale */}
      <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-4">
        <span className="text-xl font-bold text-gray-500">{family.nom?.charAt(0)}</span>
      </div>

      {/* Nom + Prénom */}
      <h2 className="text-lg font-semibold text-gray-800 mb-1">
        {family.nom} {family.prenom || ""}
      </h2>

      {/* Type famille */}
      <span className="text-sm text-gray-500 mb-2">{family.type}</span>

      {/* Localisation */}
      <p className="text-sm text-gray-500 mb-1">
        {family.ville}, {family.codePostal}
      </p>

      {/* Revenus nets */}
      {family.revenusNetsAnnuels && (
        <p className="text-sm text-gray-600">
          Revenus nets : {family.revenusNetsAnnuels.toLocaleString()} €
        </p>
      )}

      {/* Détails spécifiques */}
      <div className="mt-2 text-sm text-gray-600">
        {family.typeFamille === "Personne Physique" ? (
          <>
            {family.profession && <p>Profession : {family.profession}</p>}
            {family.entreprise && <p>Entreprise : {family.entreprise}</p>}
          </>
        ) : (
          <>
            {family.statutJuridique && <p>Statut : {family.statutJuridique}</p>}
            {family.secteurActivite && <p>Secteur : {family.secteurActivite}</p>}
          </>
        )}
      </div>

      {/* Statut client */}
      <div className="absolute bottom-4 right-4">
        <span className="inline-flex items-center px-2 py-1 text-xs font-semibold bg-blue-100 text-blue-700 rounded">
          {family.statut}
        </span>
      </div>

      {/* Overlay consulter */}
      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition rounded-xl">
        <div className="bg-white text-gray-800 font-semibold py-2 px-4 rounded-lg shadow hover:bg-gray-200 flex items-center gap-2">
          <EyeIcon className="w-5 h-5" />
          Consulter
        </div>
      </div>
    </div>
  );
}
